import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Award } from 'lucide-react';
export function Team() {
  return <section id="equipo" className="py-24 bg-cream-dark" data-id="element-251">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252">
        <div className="text-center mb-16" data-id="element-253">
          <h2 className="text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-254">
            Nuestro Equipo
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-255">
            Manos expertas a tu servicio
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-256">
          {/* Mery Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-257">
            <div className="w-40 h-40 mx-auto rounded-full overflow-hidden border-4 border-cream mb-6 relative" data-id="element-258">
              <img src="https://cdn.magicpatterns.com/uploads/eU1xrf31CurzuWJrtLtiTe/SaveClip.App_624709530_17955820761062830_8437033393897013793_n.jpg" alt="Mery" className="w-full h-full object-cover object-top" data-id="element-259" />
            </div>
            <h4 className="text-2xl font-serif text-charcoal mb-1" data-id="element-260">Mery</h4>
            <p className="text-rosegold font-medium text-sm mb-4 uppercase tracking-wide" data-id="element-261">
              Fundadora & Especialista en Uñas y Pestañas
            </p>
            <p className="text-charcoal-light font-light mb-6" data-id="element-262">
              Con más de 5 años de experiencia perfeccionando técnicas
              internacionales, Mery lidera el estudio con una pasión
              inquebrantable por el detalle y la estética elegante.
            </p>
            <a href="https://instagram.com/studiomery_" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-cream text-charcoal hover:bg-rosegold hover:text-white transition-colors" data-id="element-263">
              <Instagram size={18} data-id="element-264" />
            </a>
          </motion.div>

          {/* Masseur Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-265">
            <div className="w-40 h-40 mx-auto rounded-full overflow-hidden border-4 border-cream mb-6 relative" data-id="element-266">
              <img src="https://cdn.magicpatterns.com/uploads/bnTmNuzBZ8oR4tnno5s5Zt/Captura_de_pantalla_2026-06-10_085811.png" alt="Masajista" className="w-full h-full object-cover object-top" data-id="element-267" />
            </div>
            <h4 className="text-2xl font-serif text-charcoal mb-1" data-id="element-268">
              Alejandro
            </h4>
            <p className="text-rosegold font-medium text-sm mb-4 uppercase tracking-wide" data-id="element-269">
              Masajista Terapéutico Certificado
            </p>
            <p className="text-charcoal-light font-light mb-6" data-id="element-270">
              Especialista en técnicas de recuperación muscular y relajación
              profunda. Su enfoque terapéutico garantiza un alivio real y
              duradero para el estrés diario.
            </p>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cream rounded-full text-charcoal text-sm font-medium" data-id="element-271">
              <Award size={16} className="text-rosegold" data-id="element-272" />
              Certificado / Matriculado
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}